import { render, staticRenderFns } from "./public-organization-booking-form.vue?vue&type=template&id=18956a80&scoped=true&"
import script from "./public-organization-booking-form.ts?vue&type=script&lang=ts&"
export * from "./public-organization-booking-form.ts?vue&type=script&lang=ts&"
import style0 from "./public-organization-booking-form.scss?vue&type=style&index=0&id=18956a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18956a80",
  null
  
)

export default component.exports